import './_product-video-text.scss';

export default () => {};
